/**
 * Vendor chat ships disabled: unlike the other portal features, a missing or blank
 * configuration value means off, so a client only gets the chat once they opt in from
 * Purchasing/Payments Portal Configuration Management.
 */
export function isChatEnabled(config: any): boolean {
  return (config?.chatEnabled ?? '').toString().toLowerCase() === 'true';
}

export function isChatEnabledFromStorage(): boolean {
  try {
    return isChatEnabled(JSON.parse(localStorage.getItem('portalConfig') || '{}'));
  } catch {
    return false;
  }
}
